import { postData } from "./api";

export const BannersIDS = { 
  HPMainBanners: 1,
  HPOnlinePortfolio: 2,
  HPFeatureJobs: 3,
  AUMainBanners: 4,
  AUSubMainBanners: 5,
  BPAdvertisementBanners: 6,
  RPManageJobsGrid: 7,
  RPManageJobsList: 8,
  RPMatchedPortfolios: 9,
  RPShortlistedPortfolios: 10,
  JSPDashboard: 11,
  JSPShortlist: 12,
  JSPAboutInterview: 13,
  JSPSavedJobs: 14,
  JSPAppliedJobs: 15,
  PJCBanners: 16,
  HCBanners: 17,
  HeaderBanner: 18,
};

export const commonBannerApi = async (type_id) => {
  try {
    const apiUrl = "/without-login/banners/all-banners";
    const payload = { type_id };   // shorthand for { type_id: type_id }

    const response = await postData(apiUrl, payload);

    return response;
  } catch (error) {
    console.error("Error fetching banners:", error);
    throw error; // rethrow so caller can handle it
  }
};

